import Vue from 'vue'
import Router from 'vue-router'
import Store from "./store/store";
import Auth from "./services/Auth";

import {ADMIN_ROLE, FINANCE_ROLE, hasOneOfRoles, HR_ROLE, isAuth, MANAGER_ROLE} from './middlewares/permissions';

Vue.use(Router);

const routerView = {
  render(h) {
    return h('router-view')
  }
};

const router = new Router({
  base:process.env.BASE_URL,
  scrollBehavior() {
    return {x:0, y:0}
  },
  routes:[

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path:'',
      component:() => import('./layouts/main/Main.vue'),
      children:[
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path:'/',
          name:'home',
          component:() => import('./views/home/Home.vue'),
          meta:{
            middleware:[
              isAuth,
            ]
          }
        },
        {
          path:'/profile',
          name:'profile',
          component:() => import('./views/profile/Profile.vue'),
          meta:{
            middleware:[
              isAuth,
            ]
          }
        },
        {
          path:'/change-password',
          name:'changePassword',
          component:() => import('./views/profile/ChangePassword.vue'),
          meta:{
            middleware:[
              isAuth,
            ]
          }
        },
        {
          path:'/holidays',
          component:routerView,
          children:[
            {
              path:'/',
              name:'holidays',
              component:() => import('./views/holidays/Holidays.vue'),
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                ]
              },
            },
            {
              path:':id',
              name:'holidayDetails',
              component:() => import('./views/holidays/HolidayDetails.vue'),
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                ]
              },
            },
          ]
        },
        {
          path:'/users',
          component:routerView,
          children:[
            {
              path:'/',
              name:'users',
              component:() => import('./views/users/Users.vue'),
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                ]
              },
            },
            {
              path:':id',
              component:() => import('./views/users/User.vue'),
              children:[
                {
                  path:'',
                  name:'userDetails',
                  component:() => import('./views/users/UserDetails.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                    ]
                  },
                },
                {
                  path:'userConfig',
                  name:'userConfig',
                  component:() => import('./views/users/UserConfig.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                    ]
                  },
                  beforeEnter:(to, from, next) => {
                    let userId = parseInt(to.params.id);
                    if (!userId) next(from);
                    next();
                  }
                },
                {
                  path:'userHolidays',
                  name:'userHolidays',
                  component:() => import('./views/users/UserHolidays.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                    ]
                  },
                  beforeEnter:(to, from, next) => {
                    let userId = parseInt(to.params.id);
                    if (!userId) next(from);
                    next();
                  }
                },
              ]
            },
          ]
        },
        {
          path:'/notifications',
          component:routerView,
          children:[
            {
              path:'/',
              name:'notifications',
              component:() => import('./views/notifications/Notifications.vue'),
              meta:{
                middleware:[
                  isAuth,
                ]
              },
            },
          ]
        },
        {
          path:'/configurations',
          name:'configurations',
          component:() => import('./views/configs/Configs.vue'),
          meta:{
            middleware:[
              isAuth,
              (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
            ]
          },
        },

        {
          path:'/clients',
          component:routerView,
          children:[
            {
              path:'/',
              name:'clients',
              component:() => import('./views/clients/Clients.vue'),
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                ]
              },
            },
            {
              path:':id',
              name:'clientDetails',
              component:() => import('./views/clients/ClientDetails.vue'),
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE])
                ]
              },
            },
          ]
        },
        {
          path:'/projects',
          component:routerView,
          children:[
            {
              path:'/',
              name:'projects',
              component:() => import('./views/projects/Projects.vue'),
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE, MANAGER_ROLE])
                ]
              },
            },
            {
              path:':id',
              component:() => import('./views/projects/Project.vue'),
              children:[
                {
                  path:'',
                  name:'projectDetails',
                  component:() => import('./views/projects/ProjectDetails.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE, MANAGER_ROLE])
                    ]
                  },
                },
                {
                  path:'assignees',
                  name:'projectAssignees',
                  component:() => import('./views/projects/ProjectAssignees.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE, MANAGER_ROLE])
                    ]
                  },
                  beforeEnter:(to, from, next) => {
                    let projectId = parseInt(to.params.id);
                    if (!projectId) next(from);
                    next();
                  }
                },
                {
                  path:'performance',
                  name:'projectPerformance',
                  component:() => import('./views/projects/ProjectPerformance.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, HR_ROLE, MANAGER_ROLE])
                    ]
                  },
                  beforeEnter:(to, from, next) => {
                    let projectId = parseInt(to.params.id);
                    if (!projectId) next(from);
                    next();
                  }
                },
                {
                  path:'finance',
                  name:'projectFinance',
                  component:() => import('./views/projects/ProjectFinance.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, FINANCE_ROLE, MANAGER_ROLE])
                    ]
                  },
                  beforeEnter:(to, from, next) => {
                    let projectId = parseInt(to.params.id);
                    if (!projectId) next(from);
                    next();
                  }
                },
              ]
            },
          ]
        },
        {
          path:'/payments',
          component:() => import('./views/payments/PaymentContainer.vue'),
          children:[
            {
              path:'/',
              component:() => import('./views/payments/Payments.vue'),
              name:'payments',
              meta:{
                middleware:[
                  isAuth,
                  (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, FINANCE_ROLE])
                ]
              },
            },
            {
              path:'/maintenance',
              component:routerView,
              children:[
                {
                  path:'/',
                  name:'maintenancePayments',
                  component:() => import('./views/maintenancePayments/MaintenancePayments.vue'),
                  meta:{
                    middleware:[
                      isAuth,
                      (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, FINANCE_ROLE])
                    ]
                  },
                },
                {
                  path:':id',
                  component:() => import('./views/maintenancePayments/MaintenancePayment.vue'),
                  children:[
                    {
                      path:'',
                      name:'maintenancePaymentDetails',
                      component:() => import('./views/maintenancePayments/MaintenancePaymentDetails.vue'),
                      meta:{
                        middleware:[
                          isAuth,
                          (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, FINANCE_ROLE])
                        ]
                      },
                    },
                    {
                      path:'transactions',
                      name:'maintenancePaymentTransactions',
                      component:() => import('./views/maintenancePayments/MaintenancePaymentTransactions.vue'),
                      meta:{
                        middleware:[
                          isAuth,
                          (nav) => hasOneOfRoles(nav, [ADMIN_ROLE, FINANCE_ROLE])
                        ]
                      },
                    },
                  ]
                },
              ]
            }
          ],
        },
        {
          path:'/ptos',
          component:() => import('./views/ptos/PTOs.vue'),
          meta:{
            middleware:[
              isAuth,
            ]
          },
          children:[
            {
              path:'',
              name:'personalPTOs',
              component:() => import('./views/ptos/PersonalPTOs.vue'),
              meta:{
                middleware:[
                  isAuth,
                ]
              },
            },
            {
              path:'approvePtos',
              name:'approvePtos',
              component:() => import('./views/ptos/ApprovePTOs.vue'),
              meta:{
                middleware:[
                  isAuth,
                ]
              },
              beforeEnter:(to, from, next) => {
                let hasAccess = Auth.hasOneOfRoles([ADMIN_ROLE, HR_ROLE])
                if (hasAccess) next()
                else next({name:'personalPTOs', params:{id:Store.state.me.id}})
              }
            },
          ]
        },
        {
          path:'/timecard',
          component:() => import('./views/timecards/Timecards.vue'),
          meta:{
            middleware:[
              isAuth,
            ]
          },
          children:[
            {
              path:'',
              name:'approveTimecards',
              component:() => import('./views/timecards/ApproveTimecards.vue'),
              meta:{
                middleware:[
                  isAuth,
                ]
              },
              beforeEnter:(to, from, next) => {
                let hasAccess = Auth.hasOneOfRoles([ADMIN_ROLE, HR_ROLE, MANAGER_ROLE])
                if (hasAccess) next()
                else next({name:'timecard', params:{id:Store.state.me.id}})
              }
            },
            {
              path:'timecard',
              name:'timecard',
              component:() => import('./views/timecards/Timecard.vue'),
              meta:{
                middleware:[
                  isAuth,
                ]
              },
            },
          ]
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path:'',
      component:() => import('@/layouts/full-page/FullPage.vue'),
      children:[
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path:'/pages/login',
          name:'page-login',
          component:() => import('@/views/pages/Login.vue')
        },
        {
          path:'/pages/error-404',
          name:'page-error-404',
          component:() => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path:'*',
      redirect:'/pages/error-404'
    }
  ],
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({...context, next:nextMiddleware});
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {

    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({...context, next:nextMiddleware});
  }

  return next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
